import { PreOrderTimeSlot } from '@rbi-ctg/menu';

export const PreOrderTimeModalModeConst = {
  PRESELECT: 'PRESELECT',
  DELIVERY_TIMES_UPDATED: 'DELIVERY_TIMES_UPDATED',
} as const;

export type PreOrderTimeModalMode =
  (typeof PreOrderTimeModalModeConst)[keyof typeof PreOrderTimeModalModeConst];

export interface PreOrderTimeModalProps {
  isOpen: boolean;
  onClose: VoidFunction;
  preOrderTimeSlots?: PreOrderTimeSlot[] | null;
  onPreOrderSlotSelected: (timeslot: PreOrderTimeSlot) => void;
  mode?: PreOrderTimeModalMode;
}
